<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-04-16 09:51:43
 * @LastEditTime : 2026-03-26 11:24:05
 * @LastEditors  : yangxr
 * @Description  : 交工资料(新版)
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\components_data\dataCompletionNew.vue
-->
<template>
  <div class="pages_content table">
    <el-main style="display: flex">
      <div>
        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span style="display: inline-block; margin-bottom: 10px">
                <span style="margin-right: 12px">交工工程名称</span>
                <el-input v-model="tableParam.handOverEngineeringName" style="width: 240px" clearable />
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all"
                @click="(tableParam.page = 1), gettableData()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              <el-button icon="el-icon-download" size="medium" class="bottom_all_two" style="margin-left: 12px"
                @click="exportDialog = true">导 入</el-button>
            </div>
          </div>
        </el-collapse-transition>
        <div class="hr"></div>
        <div class="card">
          <!-- <div class="card_nav">
              <div></div>
              <div>
                <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                  <el-link :underline="false">
                    <span class="el-icon--left">
                      <i class="iconfont iconicon_button_filtrate"></i>
                    </span>
                    筛选
                  </el-link>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in table" :key="index">
                      <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div> -->
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :height="screenHeight - 400"
              :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="tableData"
              tooltip-effect="dark">
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                  <template slot-scope="scope">
                    <span v-if="item.label == '配合比'">
                      <el-link v-if="scope.row.engineeringMixProportionStatus == 1" type="danger" :underline="false"
                        @click="mixOpen(scope.row)">未配置</el-link>
                      <el-link v-if="scope.row.engineeringMixProportionStatus == 2" type="success" :underline="false"
                        @click="mixOpen(scope.row)">已配置</el-link>
                    </span>
                    <span v-else-if="item.label == '厂家'">
                      <el-link v-if="scope.row.manufacturerSettingStatus == 1" type="danger" :underline="false"
                        @click="manufacturerOpen(scope.row)">未配置</el-link>
                      <el-link v-if="scope.row.manufacturerSettingStatus == 2" type="success" :underline="false"
                        @click="manufacturerOpen(scope.row)">已配置</el-link>
                    </span>
                    <span v-else-if="item.label == '附件'">
                      <el-link type="primary" :underline="false" @click="lookFileDetail(scope.row)">查看</el-link>
                      <el-link type="primary" :underline="false" style="margin-left: 12px"
                        @click="lookFile(scope.row)">下载</el-link>
                    </span>
                    <span v-else-if="item.label == '操作'">
                      <el-link type="danger" :underline="false" @click="deleteHandOverData(scope.row.id)">删除</el-link>
                      <el-link type="success" :underline="false" style="margin-left: 12px"
                        @click="exportOpen(scope.row)">导出</el-link>
                    </span>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </div>
    </el-main>
    <div class="card_bottom">
      <div class="card_bottom_left">
        <div class="top_page_totle">总共{{ total }}条</div>
        <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
          :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
          @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
      </div>
      <div>
        <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
      </div>
    </div>
    <!-- 导入 -->
    <el-dialog v-dialogDrag :visible.sync="exportDialog" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">导入交工信息</span>
      <div v-loading="loading" element-loading-text="数据解析中..." element-loading-background="rgba(0, 0, 0, 0.8)"
        class="dialoginfo" style="text-align: center">
        <el-upload class="upload-demo" :on-success="fileSuccess" :before-upload="filebefore" :show-file-list="false" drag
          action="/resource/resources/upload" name="file" :headers="upheader">
          <i slot="trigger" class="el-icon-upload"></i>
          <div slot="trigger" class="el-upload__text">
            将文件拖到此处，或
            <em>点击选取文件</em>
          </div>
        </el-upload>
        <div style="padding-top: 10px">
          <el-button class="bottom_all" style="margin-left: 0" @click="importSubmit()">下载模板</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="exportDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 配合比  -->
    <el-dialog v-dialogDrag :visible.sync="mixDig" width="660px">
      <span slot="title" class="dialog-title">配合比设置 </span>
      <div class="dialogOtherinfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="mixTableData" tooltip-effect="dark">
          <el-table-column label="年份" align="center" width="100" prop="year"> </el-table-column>
          <el-table-column label="标号" align="center" width="100" prop="strengthGrade"> </el-table-column>
          <el-table-column label="配合比" align="center" width="auto">
            <template slot-scope="scope">
              <el-link v-if="scope.row.labelMixProportionStatus == 1" type="danger" :underline="false"
                @click="mixSelectOpen(scope.row)">选择</el-link>
              <el-link v-if="scope.row.labelMixProportionStatus == 2" type="success" :underline="false"
                @click="mixSelectOpen(scope.row)">{{ scope.row.mixRatioName }}</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ mixTableParams.total }}条</div>
          <el-pagination :current-page.sync="mixTableParams.page" :page-size="mixTableParams.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
            :total="mixTableParams.total" @size-change="mixSizeChange"
            @current-change="getEngineerMixDetail()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
            @click="getEngineerMixDetail">刷新</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="mixDig = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 配合比选择 -->
    <el-dialog v-dialogDrag :visible.sync="mixSelectDig" width="540px">
      <span slot="title" class="dialog-title"> 配合比 </span>
      <div class="dialogOtherinfo">
        <el-form ref="mixSelectForm" :inline="true" :model="mixSelectForm" label-width="110px">
          <el-form-item>
            <span slot="label">产品名称</span>
            <span>{{ mixSelectForm.strengthGrade }}</span>
          </el-form-item>
          <el-form-item>
            <span slot="label">年份</span>
            <span>{{ mixSelectForm.year }}</span>
          </el-form-item>
          <el-form-item>
            <span slot="label">配合比类型</span>
            <el-select ref="mixType" v-model="mixSelectForm.mixType" style="width: 250px" placeholder="请选择"
              @change="changeMixType">
              <el-option :key="1" label="通用配合比" :value="1"> </el-option>
              <el-option :key="2" label="专用配合比" :value="2"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">配合比名称</span>
            <el-select ref="mixRatioId" v-model="mixSelectForm.mixRatioId" style="width: 250px" placeholder="请选择"
              filterable>
              <el-option v-for="item in mixList" :key="item.id" :label="item.name" :value="item.id"
                @click.native="changeMixRatio(item)">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">试验内容</span>
            <el-input v-model="mixSelectForm.testContent" style="width: 250px" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="mixSelectDig = false">取 消</el-button>
        <el-button class="bottom_all" @click="saveMix()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 厂家  -->
    <el-dialog v-dialogDrag :visible.sync="manufacturerDig" width="660px">
      <span slot="title" class="dialog-title">厂家选择 </span>
      <div class="dialogOtherinfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="manufacturerTableData" tooltip-effect="dark">
          <el-table-column label="原物料名称" align="center" width="100" prop="rawName"> </el-table-column>
          <el-table-column label="规格型号" align="center" width="100" prop="specification"> </el-table-column>
          <el-table-column label="厂家" align="center" width="auto">
            <template slot-scope="scope">
              <el-select ref="manufacturerId" v-model="scope.row.manufacturerId" style="width: 250px" placeholder="请选择"
                filterable>
                <el-option v-for="item in manufacturerMixList" :key="item.id" :label="item.itemName" :value="item.id"
                  @click.native="changeManufacturer(item, scope.$index)">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="manufacturerDig = false">关 闭</el-button>
        <el-button class="bottom_all" @click="saveManufacturer()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导出  -->
    <el-dialog v-dialogDrag :visible.sync="exportDig" width="860px">
      <span slot="title" class="dialog-title">导出交工资料</span>
      <div class="dialogOtherinfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="exportTableData" tooltip-effect="dark">
          <el-table-column label="检测人类别" align="center" width="200" prop="rawName">
            <template slot-scope="scope">
              {{ checkPersonType[scope.row.type] }}
            </template>
          </el-table-column>
          <el-table-column label="签发人" align="center" width="auto">
            <template slot-scope="scope">
              <!-- <el-cascader :ref="'signerId' + scope.$index" :key="'signerId' + scope.$index" v-model="scope.row.signerIds"
                style="width: 120px" :options="userList" :show-all-levels="false" :props="{ value: 'id', label: 'name' }"
                collapse-tags filterable @change="
                  $nextTick(() => {
                    (scope.row.signer = $refs['signerId' + scope.$index].getCheckedNodes()[0].label)
                      (scope.row.signerId = $refs['signerId' + scope.$index].getCheckedNodes()[0].value)
                  })
                  "></el-cascader> -->
              <el-select :ref="'signerId' + scope.$index" :key="'signerId' + scope.$index" v-model="scope.row.signerId"
                style="width: 120px" placeholder="请选择" filterable clearable remote
                :remote-method="query => remoteSearch(query, scope.$index, 'remoteUserList1')" :loading="userLoading">
                <el-option v-for="item in scope.row.remoteUserList1" :key="item.id" :label="item.name" :value="item.id"
                  @click.native="scope.row.signer = item.name">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="校核人" align="center" width="auto">
            <template slot-scope="scope">
              <!-- <el-cascader :ref="'checkerId' + scope.$index" :key="'checkerId' + scope.$index"
                v-model="scope.row.checkerIds" style="width: 120px" :options="userList" :show-all-levels="false"
                :props="{ value: 'id', label: 'name' }" collapse-tags filterable @change="
                  $nextTick(() => {
                    (scope.row.checker = $refs['checkerId' + scope.$index].getCheckedNodes()[0].label)
                      (scope.row.checkerId = $refs['checkerId' + scope.$index].getCheckedNodes()[0].label)
                  })
                  "></el-cascader> -->
              <el-select :ref="'checkerId' + scope.$index" :key="'checkerId' + scope.$index" v-model="scope.row.checkerId"
                style="width: 120px" placeholder="请选择" filterable clearable remote
                :remote-method="query => remoteSearch(query, scope.$index, 'remoteUserList2')" :loading="userLoading">
                <el-option v-for="item in scope.row.remoteUserList2" :key="item.id" :label="item.name" :value="item.id"
                  @click.native="scope.row.checker = item.name">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="试验人" align="center" width="auto">
            <template slot-scope="scope">
              <el-select :ref="'testerId' + scope.$index" :key="'testerId' + scope.$index" v-model="scope.row.testerIds"
                style="width: 120px" placeholder="请选择" filterable  remote multiple
                :remote-method="query => remoteSearch(query, scope.$index, 'remoteUserList3')" :loading="userLoading"  @change="(val) => setTester(val, scope.$index)">
                <el-option v-for="item in scope.row.remoteUserList3" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="填表日期" align="center" width="auto">
            <template slot-scope="scope">
              <el-date-picker v-if="scope.row.type == 3" v-model="scope.row.fillDate" style="width: 120px" type="date"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="exportDig = false">关 闭</el-button>
        <el-button class="bottom_all" @click="confirmExport()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, deleteHandOverData, getEngineerMixDetail, matchMixRatio, saveMixRatio, matchMixRatioMaterials, saveManufacturer, queryManufacturer, exportHandOver, getPourParts } from "@/api/smart/components_data/dataCompletionNew.js";
import { getUserInfo } from "@/utils/auth.js";
import { getToken, getUserId } from "@/utils/auth";
import { getDicType } from '@/api/common';
import {
  queryPage as userQuery,
} from "@/api/basedata/user";
import axios from 'axios';
export default {
  components: {
  },
  mixins: [mixin],
  data() {
    return {
      table: [
        { label: "交工工程名称", prop: "handOverEngineeringName", status: true, width: "auto" },
        { label: "配合比", prop: "engineeringMixProportionStatus", status: true, width: "280" },
        { label: "厂家", prop: "manufacturerSettingStatus", status: true, width: "280" },
        { label: "附件", prop: "file", status: true, width: "280" },
        { label: "操作", prop: "", status: true, width: "200" },
      ],
      queryPage: queryPage,
      tableData: [],
      pagesType: 0,
      exportDialog: false,
      loading: false,
      upheader: {
        "access-token": getToken(),
        "user-id": getUserId(),
      },
      uploadFile: "",
      //配合比
      mixDig: false,
      mixTableData: [],
      mixTableParams: {
        page: 1,
        pageSize: 10,
        total: 0,
        id: "",
      },
      //配合比选择
      mixSelectDig: false,
      mixSelectForm: {
        handOverDataId: "", //交工工程id
        strengthGrade: "", //标号强度等级
        year: "", //年份
        mixRatioId: "", //配合比的id
        mixRatioName: "",
        mixType: "",
        testContent: "",
        flag:"",
      },
      mixListAll: [],
      mixList: [],
      //厂家
      manufacturerDig: false,
      manufacturerTableData: [],
      manufacturerMixList: [],
      //导出
      checkPersonType: ['', '配合比报告', '抗压', '强度汇总表/强度合格评定', '抗渗', '水泥检测报告', '砂石检测报告'],
      userList: [],
      exportDig: false,
      exportHandOver: exportHandOver,
      exportTableData: [
        {
          remoteUserList1: [
            { id: "77961511896748032", name: "胡江" },
          ],
          remoteUserList2: [
            { id: "60547412053331968", name: "王玮" },
          ],
          remoteUserList3: [],
          selectTesterList:[],//存放选中实验人的数据
          type: 1, //检测人类别：1配合比报告 2抗压 3强度汇总表/强度合格评定 4抗渗 5水泥检测报告 6砂石检测报告
          signerId: "77961511896748032", //签发人id
          signerIds: [],
          signer: "胡江", //签发人
          checkerId: "60547412053331968", //校核人id
          checkerIds: [], //校核人id
          checker: "王玮", //校核人
          testerId: "", //试验人id
          testerIds: [], //试验人id
          tester: "" //试验人
        },
        {
          remoteUserList1: [
            { id: "77961511896748032", name: "胡江" },
          ],
          remoteUserList2: [
            { id: "60547412053331968", name: "王玮" },
          ],
          remoteUserList3: [],
          selectTesterList:[],//存放选中实验人的数据
          type: 2,
          signerId: "77961511896748032",
          signerIds: [],
          signer: "胡江",
          checkerId: "60547412053331968",
          checkerIds: [],
          checker: "王玮",
          testerId: "",
          testerIds: [],
          tester: "",
          fillDate: "",
        },
        {
          remoteUserList1: [
            { id: "77961511896748032", name: "胡江" },
          ],
          remoteUserList2: [
            { id: "60547412053331968", name: "王玮" },
          ],
          remoteUserList3: [],
          selectTesterList:[],//存放选中实验人的数据
          type: 3,
          signerId: "77961511896748032",
          signerIds: [],
          signer: "胡江",
          checkerId: "60547412053331968",
          checkerIds: [],
          checker: "王玮",
          testerId: "",
          testerIds: [],
          tester: "",
          fillDate: "",
        },
        {
          remoteUserList1: [
            { id: "77961511896748032", name: "胡江" },
          ],
          remoteUserList2: [
            { id: "60547412053331968", name: "王玮" },
          ],
          remoteUserList3: [],
          selectTesterList:[],//存放选中实验人的数据
          type: 4,
          signerId: "77961511896748032",
          signerIds: [],
          signer: "胡江",
          checkerId: "60547412053331968",
          checkerIds: [],
          checker: "王玮",
          testerId: "",
          testerIds: [],
          tester: "",
          fillDate: "",
        },
        {
          remoteUserList1: [
            { id: "77961511896748032", name: "胡江" },
          ],
          remoteUserList2: [
            { id: "60547412053331968", name: "王玮" },
          ],
          remoteUserList3: [],
          selectTesterList:[],//存放选中实验人的数据
          type: 5,
          signerId: "77961511896748032",
          signerIds: [],
          signer: "胡江",
          checkerId: "60547412053331968",
          checkerIds: [],
          checker: "王玮",
          testerId: "",
          testerIds: [],
          tester: "",
          fillDate: "",
        },
        {
          remoteUserList1: [
            { id: "77961511896748032", name: "胡江" },
          ],
          remoteUserList2: [
            { id: "60547412053331968", name: "王玮" },
          ],
          remoteUserList3: [],
          selectTesterList:[],//存放选中实验人的数据
          type: 6,
          signerId: "77961511896748032",
          signerIds: [],
          signer: "胡江",
          checkerId: "60547412053331968",
          checkerIds: [],
          checker: "王玮",
          testerId: "",
          testerIds: [],
          tester: "",
          fillDate: "",
        },
      ],
      remoteUserList: [],
      userLoading: false,
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.tableParam = { ...this.tableParam, handOverEngineeringName: "", };
    this.gettableData();
    getDicType({ code: 'manufacturerMix' }).then(res => {
      this.manufacturerMixList = res.data.items;
    });
    //获取当前账号公司id的组织树
    let res =
      await userQuery({
        page: 1,
        pageSize: 999999,
        userEentrance: "entrance_manager"
      })
    if (res.code == 1001) {
      this.userList = res.data.data
      // this.userList = await orgUserTree(this.UserInfo.companyId);
    }
  },

  methods: {
    setTester(val,index){
      // this.exportTableData[index].testerId = this.exportTableData[index].testerId ? this.exportTableData[index].testerId + ',' + item.id : item.id
      // this.exportTableData[index].tester = this.exportTableData[index].tester ? this.exportTableData[index].tester + ',' + item.name : item.name
      let text =[]
      val.forEach(item => {
        
        let obj2 = this.exportTableData[index].selectTesterList.find(item2 => item2.id == item)
        if(obj2){
          text.push(obj2.name)
        } else {
          let obj = this.exportTableData[index].remoteUserList3.find(item2 => item2.id == item)
          if(obj){
            text.push(obj.name)
            this.exportTableData[index].selectTesterList.push(obj)
          }
        }
        
      })
      this.exportTableData[index].testerId = val.join(',')
      this.exportTableData[index].tester = text.join(',')
      console.log(this.exportTableData[index])
    },
    // 远程搜索方法，参数是输入的搜索关键词
    remoteSearch(query, index, list) {
      if (query !== '') {
        this.userLoading = true;
        // 这里用你的接口替换 fetchUserList
        userQuery({ page: 1, pageSize: 10, userEentrance: "entrance_manager", name: query }).then(res => {
          this.exportTableData[index][list] = res.data.data;  // 假设接口返回格式是 { data: [...] }
          this.userLoading = false;
        }).catch(() => {
          this.exportTableData[index][list] = [];
          this.userLoading = false;
        });
      } else {
        this.exportTableData[index][list] = [];
      }
    },
    //导出
    confirmExport() {
      let reportPersonList = this.exportTableData.reduce((acc, item) => {
        if (item.signerId && item.checkerId && item.testerId) {
          acc.push({
            signer: item.signer,
            signerId: item.signerId,
            checker: item.checker,
            checkerId: item.checkerId,
            testerId: item.testerId,
            tester: item.tester,
            type: item.type,
            fillDate: item.fillDate,
          });
        }
        return acc;
      }, []);

      if (reportPersonList.length == 0) {
        this.$message.warning('请选择人员!')
        return
      }
      let params = {
        id: this.low.id,
        reportPersonList: reportPersonList
      }
      this.$Download(this.exportHandOver, params);
    },
    exportOpen(row) {
      this.low = JSON.parse(JSON.stringify(row))
      this.exportTableData = this.$options.data().exportTableData
      this.exportTableData[2].fillDate = new Date().Format("yyyy-MM-dd")
      this.exportDig = true
    },
    //查看 下载
    lookFileDetail(row) {
      if (!row.filePath) {
        this.$message.warning('暂无附件!')
        return
      }
      if (row.filePath.endsWith('.jpg') || row.filePath.endsWith('.png') || row.filePath.endsWith('.jpeg')) {
        let imgUrl = row.filePath;
        window.open(imgUrl, "_blank");
      } else {
        this.$wps(row.path);
      }
    },
    lookFile(row) {
      if (!row.filePath) {
        this.$message.warning('暂无附件!')
        return
      }
      let imgUrl = row.filePath;
      window.open(imgUrl, "_blank");
    },
    //厂家
    async manufacturerOpen(row) {
      this.low = JSON.parse(JSON.stringify(row))
      //未配置
      if (this.low.manufacturerSettingStatus == 1) {
        await this.matchMixRatioMaterials()
      }
      //已配置
      if (this.low.manufacturerSettingStatus == 2) {
        await this.queryManufacturer()
      }
      this.manufacturerDig = true
    },
    changeManufacturer(item, index) {
      this.$set(this.manufacturerTableData[index], 'manufacturerName', item.itemName)
      //字典成员值为品牌
      this.$set(this.manufacturerTableData[index], 'manufacturerBrand', item.itemValue)
    },
    saveManufacturer() {
      let type = this.manufacturerTableData.some(item => !item.manufacturerId)
      if (type) {
        this.$message.warning('厂家不能为空！')
        return
      }
      saveManufacturer(this.manufacturerTableData).then(res => {
        if (res.code == 1001) {
          this.$message.success('保存成功！')
          this.manufacturerDig = false
          this.gettableData()
        }
      })
    },
    matchMixRatioMaterials() {
      let params = {
        page: 1,
        pageSize: 99999,
        id: this.low.id
      }
      matchMixRatioMaterials(params).then(res => {
        if (res.code == 1001) {
          this.manufacturerTableData = res.data.data.map(item => {
            return {
              id: "",
              handOverDataId: this.low.id,
              rawName: item.rawName,
              rawId: item.rawId,
              specification: item.specification,
              specificationId: item.specificationId,
              manufacturerId: "",
              formulaParameters: item.formulaParameters,
              formulaParametersId: item.formulaParametersId,
              manufacturerName: "",
              manufacturerBrand: ""
            }
          })
        }
      })
    },
    queryManufacturer() {
      let params = {
        page: 1,
        pageSize: 99999,
        id: this.low.id
      }
      queryManufacturer(params).then(res => {
        if (res.code == 1001) {
          this.manufacturerTableData = res.data.data.map(item => {
            return {
              id: item.id,
              handOverDataId: this.low.id,
              rawName: item.rawName,
              rawId: item.rawId,
              specification: item.specification,
              specificationId: item.specificationId,
              manufacturerId: item.manufacturerId,
              formulaParameters: item.formulaParameters,
              formulaParametersId: item.formulaParametersId,
              manufacturerName: item.manufacturerName,
              manufacturerBrand: item.manufacturerBrand
            }
          })
        }
      })
    },
    //配合比
    async mixOpen(row) {
      this.low = JSON.parse(JSON.stringify(row))
      this.mixTableParams.id = row.id
      await this.getEngineerMixDetail()
      this.mixDig = true
    },
    getEngineerMixDetail() {
      getEngineerMixDetail(this.mixTableParams).then(res => {
        if (res.code == 1001) {
          this.mixTableData = res.data.data
          this.mixTableParams.total = res.data.totalRows
        }
      })
    },
    mixSelectOpen(row) {
      this.mixSelectForm.year = row.year
      this.mixSelectForm.strengthGrade = row.strengthGrade
      this.mixSelectForm.handOverDataId = row.handOverDataId
      this.mixSelectForm.mixRatioId = row.mixRatioId
      this.mixSelectForm.mixRatioName = row.mixRatioName
      this.mixSelectForm.flag = row.flag
      this.mixSelectForm.id = row.id
      this.mixList = []
      matchMixRatio({ name: row.strengthGrade, date: row.year }).then(res => {
        if (res.code == 1001) {
          this.mixListAll = res.data
          if (this.mixSelectForm.mixRatioId) {
            let obj = this.mixListAll.find(item => item.id == this.mixSelectForm.mixRatioId)
            if (obj) {
              this.mixSelectForm.mixType = obj.type
              this.mixList = this.mixListAll.filter(item => item.type == this.mixSelectForm.mixType)
            }
          } else {
            this.mixSelectForm.mixType = ""
          }
          getPourParts({ strengthGrade: row.strengthGrade, year: row.year, handOverDataId: row.handOverDataId,flag:row.flag,id:row.id }).then(res2 => {
            if (res2.code == 1001) {
              this.mixSelectForm['testContent'] = res2.data.testContent
              this.mixSelectDig = true
            }
          })

        }
      })

    },
    changeMixRatio(item) {
      const index = item.name.lastIndexOf('_');  // 找到最后一个下划线的位置
      const result = item.name.substring(0, index);  // 截取从开头到最后一个下划线之前的内容
      this.mixSelectForm.mixRatioName = result
    },
    changeMixType() {
      this.mixList = this.mixListAll.filter(item => item.type == this.mixSelectForm.mixType)
      if (this.mixList.length == 1) {
        this.mixSelectForm.mixRatioId = this.mixList[0].id
      }
      if (this.mixList.length == 0) {
        this.mixSelectForm.mixRatioId = ''
        this.mixSelectForm.mixRatioName = ''
      }
    },
    saveMix() {
      if (!this.mixSelectForm.mixRatioId) {
        this.$message.warning('请选择配合比！')
        return
      }
      saveMixRatio(this.mixSelectForm).then(res => {
        if (res.code == 1001) {
          this.$message.success('保存成功！')
          this.mixSelectDig = false
          this.getEngineerMixDetail()
          this.gettableData()
        }
      })
    },
    //导入
    importSubmit() {
      window.open("https://lvshe.huashijc.com/file/group1/M00/1A/C1/ChQACmjvRaSAR9GTAAAniEiTCjY11.xlsx");
      // window.open("https://lvshe.huashijc.com/file/group1/M00/42/D9/ChQACmfzJ6iADBsEAAAnRoY9e5o62.xlsx");
    },
    fileSuccess(res) {
      console.log(res)
      if (res.code == 1001) {
        const formData = new FormData();
        formData.append('file', this.uploadFile);
        formData.append('filePath', "https://lvshe.huashijc.com/file/" + res.data.fileUrl);
        axios.post('/icps/system/sign/basics/handOverInformationV2/importHandOverData', formData, {
          headers: {
            // 'Content-Type': 'multipart/form-data',
            "access-token": getToken(),
            "user-id": getUserId(),
            "system-info": 'icps',
          }
        }).then((res2) => {
          if (res2.data.code == 1001) {
            this.$message({
              message: `导入数据成功！！！`,
              type: "success",
            });
            this.exportDialog = false
            this.gettableData();
          } else {
            console.log(res2)
            this.$message.warning(res2.data.codeMsg)
          }
          this.loading = false;
        }).catch(err => {
          console.error('第二次上传失败', err);
        });
      } else {
        this.$message.error(res.codeMsg);
      }
    },
    /*导入数据*/
    filebefore(file) {
      this.uploadFile = file
      this.loading = true;
      const isJPG = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isJPG) {
        this.$message.error("数据上传必须是 xlsx 格式!");
        this.loading = false;
      }
      return isJPG;
    },
    deleteHandOverData(id) {
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          deleteHandOverData({ id: id }).then(res => {
            if (res.code == 1001) {
              this.gettableData();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => { });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    mixSizeChange(value) {
      this.mixTableParams.pageSize = value;
      this.getEngineerMixDetail();
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam.handOverEngineeringName = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
